var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZone3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1149.118 2061",
    style: {
      enableBackground: "new 0 0 1149.118 2061"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E961B1",
      strokeWidth: 46.6102,
      strokeMiterlimit: 10
    },
    x1: 0,
    y1: 1079.341,
    x2: 1149.118,
    y2: 1079.341
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E961B1",
      strokeWidth: 46.6102,
      strokeMiterlimit: 10
    },
    d: "M0,1618.199h611.965 c51.779,0,93.754-41.974,93.754-93.75v-443.572V710.644c0-40.917-33.171-74.086-74.089-74.086H0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E961B1",
      strokeWidth: 46.6102,
      strokeMiterlimit: 10
    },
    d: "M440.9,1618.199v59.178 c0,60.827,49.312,110.137,110.141,110.137h598.077"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.468,
    y: -0.594,
    style: {
      fill: "none"
    },
    width: 1147.411,
    height: 2061
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000133519614887598021580000012829585916573345956_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone3);
export default __webpack_public_path__ + "static/media/zone_3.f6a321c5.svg";
export { ForwardRef as ReactComponent };